import axios from '@/libs/api.request'

/**
 * 周报树
 */
export const getTreeData = () => {
    return axios.request({
        url: '/api/admin/monthreport/treeData',
        method: 'post'
    })
}

/**
 * 保存备注
 */
export const saveContent = (id, state, content, content1) => {
    var data = {
        "id": id,
        "state": state,
        "content": content,
        "content1": content1
    }
    return axios.request({
        url: '/api/admin/monthreport/save1',
        data,
        method: 'post'
    })
}

/**
 * 审核周月报
 */
export const shContent = (id, state, content, content1) => {
    var data = {
        "id": id,
        "state": state,
        "content": content,
        "content1": content1
    }
    return axios.request({
        url: '/api/admin/monthreport/exam',
        data,
        method: 'post'
    })
}

/**
 * 审核周月报
 */
 export const exportPDF = (id) => {
    var data = {
        "id": id,
    }
    return axios.request({
        url: '/api/admin/monthreport/exportPDF',
        data,
        method: 'post'
    })
}